import { tokens } from '@domain-group/fe-brary';
import { solidButtonStyles } from '../utils';
export default solidButtonStyles(tokens.colors.interactive);